module.exports = __webpack_public_path__ + "1d243c08a45302a3f6e06e9239b12cf0.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/backgrounds/popups/music.png
// module id = 866
// module chunks = 0